import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import Button from "../../../../shared/components/ui/Button";

export default function ActivationModal({
  disclosure,
  onSubmit,
  isSubmitting,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  onSubmit: () => void;
  isSubmitting: boolean;
}) {
  const { isOpen, onClose } = disclosure;

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>事業者情報更新を申請する</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            現在、事業者情報は掲載一時停止中です。<br />
            このまま申請すると、承認後に自動で掲載が再開されます
          </ModalBody>

          <ModalFooter gap={2}>
            <Button color="gray" onClick={onClose} isDisabled={isSubmitting}>
              やめる
            </Button>
            <Button onClick={onSubmit} isLoading={isSubmitting}>
              申請する
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
